import { useContext } from "react";
import { BooleanField, DeleteButton, FormTab, required, SaveButton, Show, TabbedForm, TextField, Toolbar } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const InstitutionBranchShow = (props) => {

    const context = useContext(AppContext)

    const CustomToolbar = props => {
        return <Toolbar {...props} >
            <SaveButton {...props} />
            <div style={{ flexGrow: 1 }} />
            {context.profile.name === ProfileEnum.SUPERADMIN && <DeleteButton mutationMode="pessimistic" />}
        </Toolbar>
    }

    return (
        <Show {...props}>
            <TabbedForm redirect='list' mutationMode="pessimistic" toolbar={<CustomToolbar />}>
                <FormTab label={'Dados Gerais'} >
                    <TextField source="institution.name" label={'Instituição'} fullWidth disabled />
                    <TextField source="name" label="Nome" fullWidth validate={[required()]} />
                    <BooleanField source="active" label="Ativo" />
                </FormTab>
            </TabbedForm>
        </Show>
    )
}
export default InstitutionBranchShow;